import { lazy } from 'react';

import { Warn } from '@utilities/logging';

const stadiumMap = {
  62875: 'Berlin',
  52864: 'Cologne',
  57798: 'Dortmund',
  1100174: 'Dusseldorf',
  85690: 'Frankfurt',
  79089: 'Gelsenkirchen',
  53103: 'Hamburg',
  85442: 'Leipzig',
  85441: 'Munich',
  53101: 'Stuttgart',
  //Start To be removed
  57775: 'Leipzig',
  250002745: 'Dusseldorf',
  250003363: 'Stuttgart',
  62417: 'Berlin',
  250001298: 'Cologne',
  250004078: 'Dortmund',
  63462: 'Frankfurt',
  62427: 'Gelsenkirchen',
  1100043: 'Hamburg',
  74459: 'Munich',
  //End To be removed
};

export const getStadiumComponent = (id: string) => {
  if (!stadiumMap[id]) return null;
  try {
    return lazy(() => import(`../components/Stadiums/Maps/${stadiumMap[id]}`));
  } catch (e) {
    Warn(`Stadium Component ../components/Stadiums/Maps/${stadiumMap[id]} not found`, e);
  }
};
